/* ==========================================================================
   Calculadora de Frete — Cart Drawer (Vital)
   Usa os endpoints nativos da Shopify para cotar frete a partir do carrinho
   atual (mesmo mecanismo usado pelo checkout), sem precisar de app externo.

   Carregue este arquivo com "defer" no theme.liquid, ex:
   <script src="{{ 'vital-frete.js' | asset_url }}" defer></script>
   ========================================================================== */

(function () {
  "use strict";

  function formatarCEP(valor) {
    var digitos = valor.replace(/\D/g, "").slice(0, 8);
    if (digitos.length > 5) {
      return digitos.slice(0, 5) + "-" + digitos.slice(5);
    }
    return digitos;
  }

  function formatarPreco(centavos) {
    var valor = (Number(centavos) / 100).toFixed(2).replace(".", ",");
    return "R$ " + valor;
  }

  function aguardar(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }

  function buscarTaxasDeFrete(cep) {
    var params = "shipping_address[zip]=" + encodeURIComponent(cep) +
      "&shipping_address[country]=Brazil";

    return fetch("/cart/prepare_shipping_rates.json?" + params, {
      method: "POST",
      headers: { "Content-Type": "application/json" }
    }).then(function () {
      return consultarTaxasComRetentativa(params, 0);
    });
  }

  function consultarTaxasComRetentativa(params, tentativa) {
    var MAX_TENTATIVAS = 6;

    return fetch("/cart/async_shipping_rates.json?" + params, {
      headers: { Accept: "application/json" }
    }).then(function (resposta) {
      if (resposta.status === 202 && tentativa < MAX_TENTATIVAS) {
        return aguardar(900).then(function () {
          return consultarTaxasComRetentativa(params, tentativa + 1);
        });
      }
      if (!resposta.ok) {
        throw new Error("Não foi possível calcular o frete.");
      }
      return resposta.json();
    });
  }

  function iniciar(container) {
    var form = container.querySelector("[data-frete-form]");
    var input = container.querySelector("[data-frete-input]");
    var botao = container.querySelector("[data-frete-botao]");
    var mensagem = container.querySelector("[data-frete-mensagem]");
    var listaResultados = container.querySelector("[data-frete-resultados]");

    input.addEventListener("input", function () {
      input.value = formatarCEP(input.value);
      input.setAttribute("aria-invalid", "false");
    });

    form.addEventListener("submit", function (evento) {
      evento.preventDefault();

      var cep = input.value.replace(/\D/g, "");

      if (cep.length !== 8) {
        input.setAttribute("aria-invalid", "true");
        exibirMensagem("erro", "Digite um CEP válido.");
        return;
      }

      calcular(cep);
    });

    function exibirMensagem(tipo, texto) {
      mensagem.textContent = texto;
      mensagem.setAttribute("data-tipo", tipo);
      listaResultados.setAttribute("data-visivel", "false");
      listaResultados.innerHTML = "";
    }

    function limparMensagem() {
      mensagem.textContent = "";
      mensagem.removeAttribute("data-tipo");
    }

    function exibirResultados(taxas) {
      limparMensagem();
      listaResultados.innerHTML = "";

      taxas.forEach(function (taxa) {
        var item = document.createElement("li");
        item.className = "frete-resultado";
        item.innerHTML =
          '<span class="frete-resultado__info">' +
            '<span class="frete-resultado__nome"></span>' +
            (taxa.delivery_date
              ? '<span class="frete-resultado__prazo"></span>'
              : "") +
          "</span>" +
          '<span class="frete-resultado__preco"></span>';

        item.querySelector(".frete-resultado__nome").textContent = taxa.name;
        if (taxa.delivery_date) {
          item.querySelector(".frete-resultado__prazo").textContent = taxa.delivery_date;
        }
        item.querySelector(".frete-resultado__preco").textContent =
          formatarPreco(taxa.price);

        listaResultados.appendChild(item);
      });

      listaResultados.setAttribute("data-visivel", "true");
    }

    function calcular(cep) {
      botao.setAttribute("data-loading", "true");
      botao.disabled = true;
      limparMensagem();
      listaResultados.setAttribute("data-visivel", "false");

      buscarTaxasDeFrete(cep)
        .then(function (dados) {
          var taxas = (dados && dados.shipping_rates) || [];
          if (taxas.length === 0) {
            exibirMensagem("vazio", "Nenhuma opção de frete encontrada para este CEP.");
            return;
          }
          exibirResultados(taxas);
        })
        .catch(function () {
          exibirMensagem("erro", "Não foi possível calcular o frete agora. Tente novamente.");
        })
        .finally(function () {
          botao.removeAttribute("data-loading");
          botao.disabled = false;
        });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-frete-calculadora]").forEach(iniciar);
  });

  document.addEventListener("cart:updated", function () {
    document.querySelectorAll("[data-frete-calculadora]").forEach(function (container) {
      container.querySelector("[data-frete-resultados]").setAttribute("data-visivel", "false");
      var mensagem = container.querySelector("[data-frete-mensagem]");
      mensagem.textContent = "";
      mensagem.removeAttribute("data-tipo");
    });
  });
})();
